/**
 * Legacy theme tokens.
 *
 * These values are mirrored as CSS custom properties in globals.css
 * (prefixed --ck-*). New components should prefer CSS variables or
 * Tailwind utility classes. This JS object remains for the inline-style
 * components that were migrated from react-jss.
 */

const color = {
    brightBlue: 'var(--ck-bright-blue, #3498db)',
    darkGrayishBlue: 'var(--ck-dark-grayish-blue, #8b8d94)',
    darkRed: 'var(--ck-dark-red, #a90000)',
    grayishBlue: 'var(--ck-grayish-blue, #A4A6B3)',
    grayishBlue2: 'var(--ck-grayish-blue-2, #9fa2b4)',
    grayishBlue3: 'var(--ck-grayish-blue-3, #bdc3c7)',
    lightBlue: 'var(--ck-light-blue-accent, #3751FF)',
    lightGrayishBlue: 'var(--ck-light-grayish-blue, #F7F8FC)',
    lightGrayishBlue2: 'var(--ck-light-grayish-blue-2, #DFE0EB)',
    paleBlue: 'var(--ck-pale-blue, #DDE2FF)',
    paleBlueTransparent: 'var(--ck-pale-blue-transparent, rgb(168 170 180))',
    veryDarkGrayishBlue: 'var(--ck-very-dark-grayish-blue, #373a47)',
    themeBgColor: 'var(--ck-theme-bg, #f7f7f7)',
    whiteColor: 'var(--ck-text-color, #000000)',
    activeBg: 'var(--ck-active-bg, #e8e8e8)',
};

const typography = {
    cardTitle: {
        fontWeight: 'bold',
        fontSize: 19,
        lineHeight: '24px',
        letterSpacing: '0.4px',
    },
    smallSubtitle: {
        fontSize: 12,
        lineHeight: '16px',
        letterSpacing: '0.1px',
    },
    link: {
        fontWeight: '600',
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: '0.2px',
        color: color.lightBlue,
        textAlign: 'right',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    itemTitle: {
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: 0.2,
    },
    title: {
        fontWeight: 'bold',
        fontSize: 24,
        lineHeight: '30px',
        letterSpacing: 0.3,
    },
};

export default {
    color,
    typography,
};
